import { Visibility as VisibilityIcon } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { useFormikContext } from 'formik';
import { useIntl } from 'react-intl';
import { useReportCtx } from '../../../report-ctx';

/**
 * Visualize report button. Same style as list-view RefreshButton (outlined, secondary).
 */
export const VisualizeReportBtn = () => {
  const fp = useFormikContext<{ _format: string }>();
  const ctx = useReportCtx();
  const { $t } = useIntl();

  return (
    <LoadingButton
      size="small"
      variant="outlined"
      color="secondary"
      loading={ctx.isLoading}
      onClick={() => fp.submitForm()}
      disabled={!fp.isValid}
      startIcon={<VisibilityIcon />}
    >
      {$t({ id: 'common.visualize', defaultMessage: 'Visualizar' })}
    </LoadingButton>
  );
};
